export const uniqId = (prefix = '') => `${prefix}${Math.random().toString(36).slice(2, 11)}`;
